import { DeepstreamClient } from "@deepstream/client";
import { LocalStorage } from "quasar";
import { mobileOrDesktop } from "../device";

export default class {
  constructor(connectionUrl, redirect) {
    this.connectionUrl = connectionUrl;
    this.redirect = redirect;
    this.client = new DeepstreamClient(connectionUrl);
  }

  async login(username, password, origin = "consumer") {
    if (this.client.getConnectionState() === "OPEN") {
      return;
    }
    this.listenConnection();
    const port = location.port === 80 ? "" : `:${location.port}`;
    const user = await this.client.login({
      origin: origin,
      username: username,
      password: "*",
      host: `${window.location.hostname}${port}`,
    });
    return user;
  }

  listenConnection() {
    this.client.on("connectionStateChanged", (connectionState) => {
      log.debug(`connectionState: ${connectionState}`);
      switch (connectionState) {
        case "OPEN":
          break;
        case "CLOSED":
        case "ERROR":
          break;
        default:
      }
    });
  }

  async send(method, params = {}, timeout = 10000, debug = true) {
    return new Promise((resolve, reject) => {
      if (this.client.getConnectionState() !== "OPEN") {
        reject("DS Client not connected");
      }
      const port = location.port === 80 ? "" : `:${location.port}`;
      if (debug) {
        log.group(`RPC: ${method}`);
        log.debug("SEND: ", params);
      }
      let localTimeout = false;
      const timeoutId = setTimeout(() => {
        if (debug) {
          log.debug("RECV: ", "timeout");
          log.groupEnd();
        }
        localTimeout = true;
        reject("timeout");
      }, timeout);

      try {
        this.client.rpc.make(method, params, (err, result) => {
          if (localTimeout) return;
          clearTimeout(timeoutId);
          if (err) {
            if (debug) {
              log.debug("RECV: ", err);
              log.groupEnd();
            }
            reject(err);
          } else {
            if (debug) {
              log.debug("RECV: ", result.data);
              log.groupEnd();
            }
            resolve(result.data);
          }
        });
      } catch (error) {
        clearTimeout(timeoutId);
        throw { ...error, methodAndParams: { method, params } };
      }
    });
  }

  logout() {
    this.client.close();
    LocalStorage.remove("sid");
    LocalStorage.remove("uid");
    mobileOrDesktop("/end-session");
  }
}
